<div ngbDropdown container="body" #dropdown class="action-menu-wrapper">
  <button
    [icon]="buttonIcon"
    ngbDropdownToggle
    [variant]="buttonVariant"
    [attr.data-testid]="testId"
    [disabled]="isDisabled"
  ></button>

  <span *ngIf="selectedCount > 0" class="selection-badge">
    {{ selectedCount }}
  </span>

  <div
    class="menu"
    ngbDropdownMenu
    aria-labelledby="trigger"
    (mouseleave)="onMouseLeave()"
    (mouseenter)="onMouseEnter()"
  >
    <man-action-menu-items
      [options]="options"
      [data]="data"
    ></man-action-menu-items>
  </div>
</div>
